import { useElementSize } from '@mantine/hooks';
import sortBy from 'lodash.sortby';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';

const TopReferringOrgs = ({ data = [] }) => {
	const { ref, width } = useElementSize();
	const chartData = data.reduce((prev, row) => {
		if (!prev[row.ref_agency_name2]) {
			prev[row.ref_agency_name2] = 1;
		} else {
			prev[row.ref_agency_name2]++;
		}
		return prev;
	}, {});
	const mappedData = sortBy(
		Object.entries(chartData).map(([category, count]) => ({
			category,
			count,
		})),
		['count'],
	).reverse();
	const categories = mappedData.map(({ category }) => category);
	const seriesData = mappedData.map(({ count }) => count);
	const height = Math.max(mappedData.length * 50, 100);
	return (
		<div ref={ref}>
			<div className="text-xl">Top Referring Orgs</div>
			<Chart
				type="bar"
				width={width}
				height={height}
				options={{
					colors: ['#3abddb'],
					xaxis: { categories },
					plotOptions: { bar: { horizontal: true } },
				}}
				series={[{ name: 'Count', data: seriesData }]}
			/>
		</div>
	);
};

TopReferringOrgs.propTypes = {
	data: PropTypes.array,
};

export default TopReferringOrgs;
